/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Col_DriverInputs */

const en_cases_col_driver = /** @type {(inputs: Cases_Col_DriverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driver / Claimant`)
};

const pt_br2_cases_col_driver = /** @type {(inputs: Cases_Col_DriverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motorista / Requerente`)
};

/**
* | output |
* | --- |
* | "Driver / Claimant" |
*
* @param {Cases_Col_DriverInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_col_driver = /** @type {((inputs?: Cases_Col_DriverInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Col_DriverInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_col_driver(inputs)
	return pt_br2_cases_col_driver(inputs)
});